import React, { Suspense, lazy } from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";
import { store } from "./redux/store";
const PartnerPageRouterWrapper = lazy(
  () => import("./PartnerPageRouterWrapper"),
);

const App = ({ project, cloudinary }) => {
  return (
    <Provider store={store}>
      <Router>
        <Suspense
          fallback={
            <div
              style={{
                margin: "0 auto",
                backgroundColor: "#faf7f7",
                width: "100%",
                minHeight: "100vh",
              }}
            />
          }
        >
          <PartnerPageRouterWrapper project={project} cloudinary={cloudinary} />
        </Suspense>
      </Router>
    </Provider>
  );
};

export default App;
